import { Callout } from "@clipboard-health/ui-components";
import { APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import pluralize from "pluralize";
import { useHistory } from "react-router-dom";

import { SHIFT_DISCOVERY_BLOCKS_PATH } from "../../ShiftDiscovery/paths";
import { useShiftModalsDataContext } from "../../ShiftDiscovery/useShiftModalsDataContext";

interface ShiftBlocksCalloutProps {
  count: number;
}

export function ShiftBlocksCallout(props: ShiftBlocksCalloutProps) {
  const { count } = props;

  const history = useHistory();

  const { baseNavigationPath } = useShiftModalsDataContext();

  if (count <= 0) {
    return null;
  }

  return (
    <Callout
      aria-label="View Shift Blocks"
      title={`${count} Shift ${pluralize("Block", count)}`}
      iconType="block-shift"
      sx={(theme) => ({
        backgroundColor: theme.palette.shift?.block.background,
        color: theme.palette.shift?.block.text,
      })}
      onClick={() => {
        logEvent(APP_V2_USER_EVENTS.OPEN_SHIFTS_CALLOUT_VIEWED, { type: "shiftBlocks", count });
        history.push(`${baseNavigationPath}/${SHIFT_DISCOVERY_BLOCKS_PATH}?allRoles=true`);
      }}
    />
  );
}
